// const adress = process.env.VUE_APP_API + "/";
// const adress = "http://10.61.181.30:9028/";
// const adress = "http://develop.issedu365.com:9028/";
// const adress = "http://10.16.54.158:9018/";
// const adress = "http://114.116.20.243:9023/";//软通教育测试数据
const adress = "/";

const interfaceObj = {
  login: adress + "login", //登录
  dataTypeTree: adress + 'tableStructure/dataTypeTree', //表结构管理树
  defaultpage: adress +'miwebsite/v1/pageconent/defaultpage/',//默认页面
  getpage: adress +'miwebsite/v1/pageconent/getpage/',//默认页面
};
export {
  interfaceObj
};

